import { render, staticRenderFns } from "./SupportPage.vue?vue&type=template&id=063989cc&scoped=true"
import script from "./SupportPage.vue?vue&type=script&lang=ts"
export * from "./SupportPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063989cc",
  null
  
)

export default component.exports